import React, { useState } from 'react';
import { DeviationEvent, DeviationGroups } from './fetchDeviations';
import './DeviationList.scss';
import { postNewDeviation } from './DeviationForm';
import dayjs from 'dayjs';

type DeviationListProps = {
  legId: number;
  orderId: string;
  deviationGroups: DeviationGroups;
};

const DeviationList = ({
  legId,
  orderId,
  deviationGroups,
}: DeviationListProps): JSX.Element => {
  const filteredGroups = Object.values(deviationGroups).filter(
    list => list[0].legId === legId
  );

  if (filteredGroups.length === 0) return null;

  return (
    <div className={'deviationsContainer'}>
      <h5>Deviations</h5>
      <ul>
        {filteredGroups.map((group, i) => (
          <DeviationGroupCard key={i} deviations={group} orderId={orderId} />
        ))}
      </ul>
    </div>
  );
};

type DeviationGroupCardProps = {
  orderId: string;
  deviations: DeviationEvent[];
};

const DeviationGroupCard = (props: DeviationGroupCardProps): JSX.Element => {
  const parentDeviation = props.deviations[0];

  const updateDeviations = props.deviations.slice(1);

  // const isClosed = props.deviations.some(
  //   deviation => deviation.deviationEventType === 'CLOSE'
  // );
  const isClosed =
    props.deviations[props.deviations.length - 1].deviationEventType ===
    'CLOSE';

  const [inputField, setInputField] = useState('');

  const submit = (close: boolean) => {
    postNewDeviation(props.orderId, {
      deviationEventType: close ? 'CLOSE' : 'CHANGE',
      deviationMessage: inputField,
      deviationType: 'OTHER',
      deviationVisibilities: parentDeviation.deviationVisibilities,
      parentEventId: parentDeviation.id,
    })
      .then(() => window.location.reload())
      .catch(e => console.error(e));
  };

  return (
    <li className={'deviationGroup'}>
      <div>{isClosed ? '✅' : '❗️'}</div>
      <div className={'deviationHeader'}>
        {formatDeviationMessage(parentDeviation)}
      </div>
      <div className={'deviationMetadataRow'}>
        {dayjs(parentDeviation.createdAt).format('DD.MM HH:mm')} by{' '}
        {parentDeviation.authorName} - {formatDeviationEvent(parentDeviation)}
      </div>
      {updateDeviations.map(deviation => (
        <>
          <div key={deviation.id} className={'deviationTextRow'}>
            {formatDeviationMessage(deviation)}
          </div>
          <div className={'deviationMetadataRow'}>
            {dayjs(deviation.createdAt).format('DD.MM HH:mm')} by{' '}
            {parentDeviation.authorName} - {formatDeviationEvent(deviation)}
          </div>
        </>
      ))}
      <div className={'deviationToolRow'}>
        <input
          placeholder={'Deviation message'}
          value={inputField}
          onChange={e => setInputField(e.target.value)}
        />
        <button
          disabled={inputField.length === 0}
          onClick={() => submit(false)}
        >
          Update
        </button>
        <button disabled={inputField.length === 0} onClick={() => submit(true)}>
          Close
        </button>
      </div>
    </li>
  );
};

export function formatDeviationMessage(deviation: DeviationEvent): string {
  let type = '';
  switch (deviation.deviationType) {
    case 'NOT_HOME':
      type = 'Recipient not at home';
      break;
    case 'CANT_FIND_ADDRESS':
      type = "Can't find address";
      break;
    case 'NOT_IN_CAR':
      type = 'Not in car';
      break;
    case 'DAMAGED':
      type = 'Parcel damaged';
      break;
    case 'OTHER':
      type = 'Other';
      break;
  }
  return `${type} ${deviation.message ? `: ${deviation.message}` : ''}`;
}

export function formatDeviationEvent(deviation: DeviationEvent): string {
  switch (deviation.deviationEventType) {
    case 'OPEN':
      return 'Deviation was opened';
    case 'CHANGE':
      return 'Deviation was updated';
    case 'CLOSE':
      return 'Deviation was closed';
  }
}

export default DeviationList;
